import { Component, OnInit, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OfferRewardsService } from 'app/modules/offer-rewards/services/offer-rewards.service';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { GTMDataLayerService } from 'app/shared/services/gtmDataLayer.service';
import { ConstantsKey } from 'app/shared/constant/constants-keys';


@Component({
  selector: 'spend-n-earn',
  templateUrl: './spend-n-earn.component.html',
  styleUrls: ['../../../../../@core/scss/angular/libs/select.component.scss', './spend-n-earn.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class SpendnEarnComponent implements OnInit {
  public showLoader: boolean = false;
  public selectedOption: string = 'earned'; 
  public isVoucherUnlocked = false;
  public selectedClaimAmount: number | null = null;
  public selectedItemId: number = 1;
  public selectedItem: any;
  public id: number = 0;  
  public rewardBrand;
  public availableCredits;

  public lockedVoucherList: any[] = [];
  public unlockedVoucherList:any[] = [];

 
  public earnedCredits: any[] = [];
  public spentCredits: any[] = [];

  @ViewChild('SpendModal', { static: true }) SpendModal!: TemplateRef<any>;

  public menuItems = [
    { id: 1, icon: 'spend1.png', name: 'Amazon', credits: 0, alternateIcon: 'spend2.png', isClicked: false, image: 'spend2.png', title: '', url: '' },
    { id: 2, icon: 'spend3.png', name: 'Flipkart', credits: 0, alternateIcon: 'spend4.png', isClicked: false, image: 'spend4.png', title: '', url: '' },
    { id: 3, icon: 'spend5.png', name: 'Myntra', credits: 0, alternateIcon: 'spend6.png', isClicked: false, image: 'spend6.png', title: '', url: '' },
    { id: 4, icon: 'spend7.png', name: 'Starbucks', credits: 0, alternateIcon: 'spend8.png', isClicked: false, image: 'spend8.png', title: '', url: '' },
    { id: 5, icon: 'spend9.png', name: 'Shoppers Stop', credits: 0, alternateIcon: 'spend10.png', isClicked: false, image: 'spend10.png', title: '', url: '' },
  ];
  claimAmounts = [];

  public custMobile = "";


  creditClaimHistory: any = { earnedCredits: [], spentCredits: [], claimedVouchers: [] };

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private offerRewardsService: OfferRewardsService,
    public toast: ToastrService,
    public gtmPushService: GTMDataLayerService
  ) {}

  ngOnInit() {
    this.showLoader = true;
    this.selectedItem = this.menuItems[0];

    let consumerData = localStorage.getItem(ConstantsKey.CONSUMER_DATA);
    if(consumerData) {
      consumerData = JSON.parse(consumerData);
      this.custMobile = consumerData["mobile"];
    }

    this.getConsumerCredits();
    this.getConsumerCreditClaimHistory();
    this.getRewaredLockedVoucher();
    this.getRewaredUnLockedVoucher();
    // this.getClaimReward();

  }

  selectItem(item: any): void {
    this.selectedItemId = item.id;
    this.selectedItem = item;
  }

  getConsumerCredits(): void {
    this.offerRewardsService.getConsumerCredits().subscribe(
      (data: any) => {
        this.showLoader = false;
        let creditsData = data.body;
        /* this.menuItems.forEach(item => {
          if (item.id === this.selectedItemId) {
            item.credits = data.credits || 0;
          }
        }); */

        this.rewardBrand = creditsData.rewardBrand;
        this.selectedItem = this.rewardBrand[0];
        this.selectedItemId = this.rewardBrand[0].id;
        this.availableCredits = creditsData.credits;

        let domination = this.selectedItem.denominations.split(',');
        domination.forEach((value, index) => {
          return {id: index, amount: value}
        });
        this.claimAmounts = domination;

        /* this.menuItems.forEach(item => {
          if (item.id === this.selectedItemId) {
            item.credits = data.credits || 0;
          }
        }); */


        
      },
      (error) => {
        this.showLoader = false;
        console.error('Error fetching consumer credits:', error);
      }
    );
  }


  
  getConsumerCreditClaimHistory(): void {
    this.offerRewardsService.getconsumerCreditClaimHistory().subscribe(
      (data: any) => {
        this.showLoader = false;
        if (data?.body) {  
          this.creditClaimHistory.earnedCredits = data.body.consumerCredits ?? [];
          this.creditClaimHistory.spentCredits = data.body.claimedRewardResponseForAdmin ?? [];
        } 
  
        console.log('Earned Credits (consumerCredits):', this.creditClaimHistory.earnedCredits);
        console.log('Spent Credits (claimedRewardResponseForAdmin):', this.creditClaimHistory.spentCredits);
      },
      (error) => {
        this.showLoader = false;
        console.error('Error fetching credit claim history:', error);
      }
    );
  }
  
  
  


getClaimReward(): void {

  if (!this.selectedClaimAmount) {
    this.toast.error("No claim amount selected");
      // Swal.fire("No claim amount selected");
      //console.error("Error: No claim amount selected.");
      return;
  }

  if (!this.selectedItemId) {
    this.toast.error("No item selected");
      // Swal.fire("No item selected");
      // console.error("Error: .");
      return;
  }


    let evtObj = {
      "event": "offers-and-rewards",
      "rewards_claimed_vouchers": this.selectedItem.brandname,
      "claimAmount": this.selectedClaimAmount,
      "mobile": this.custMobile != "" ? "91"+this.custMobile : ""
    };
    this.gtmPushService.dataLayerPushData(evtObj);

  this.offerRewardsService.getclaimReward(this.selectedItemId, this.selectedClaimAmount).subscribe(
      (data: any) => {
          console.log("Claim Reward Success:", data);
          this.modalService.open(this.SpendModal,  { centered: true, size: 'sm' });
      },
      (error) => {
        if(error.error.message.includes("You have insufficient balance")) {
          Swal.fire("info", error.error.message, "info");
        } else {
          this.toast.error(error.error.message);
        }
          console.error("Claim Reward Error:", error);
      }
  );
}


  toggleImage(item: any): void {
    this.selectedItemId = this.selectedItemId === item.id ? null : item.id;
  }

  
  openSpendModal() {  
    if (this.selectedClaimAmount == null || this.selectedClaimAmount === undefined) {
        console.error("Error: No claim amount selected.");
        return;
    }

    if (!this.selectedItemId) {
        console.error("Error: No item selected.");
        return;
    }

    this.modalService.open(this.SpendModal,  { centered: true, size: 'sm' });

    this.getClaimReward();
}


  closeModalAndNavigate() {
    this.modalService.dismissAll();
  }

  unlockVoucher(rewaredId) {
    this.isVoucherUnlocked = true;
    console.log("REWARD ID -- ", rewaredId);
    this.offerRewardsService.unlockReward(rewaredId).subscribe(resp => {
      this.getRewaredLockedVoucher();
      this.getRewaredUnLockedVoucher();
    }, err => {
      this.toast.error(err.error.message);

    });
  }

  getRewaredLockedVoucher() {
    this.offerRewardsService.getConsumerRewards(false).subscribe(resp => {
      this.showLoader = false;
      console.log(resp.body);
      let voucherList:any = resp.body;
      this.lockedVoucherList = voucherList;
    }, err => {
      this.showLoader = false;
      this.toast.error(err.error.message);

    });
  }

  getRewaredUnLockedVoucher() {
    this.offerRewardsService.getConsumerRewards(true).subscribe(resp => {
      this.showLoader = false;
      console.log(resp.body);
      let voucherList:any = resp.body;
      this.unlockedVoucherList = voucherList;
    }, err => {
      this.showLoader = false;
      this.toast.error(err.error.message);

    });
  }


}



  